@for (pedido of agrupamento?.pedidos; track pedido) {
    <div role="tabpanel" class="dados-pedido">

        <ng-template #tipContent>
            <div class="dados-vendedor">
                <div title="{{agrupamento?.marca}}" class="float-start media-box-object rounded-circle marca {{agrupamento?.marca}}"></div>
                <ul class="list-unstyled float-start">
                    <li>
                        <b>{{ 'buyer.dados-pedido.tip-vendedor.vendedor' | translate}}:</b> {{pedido.seller_name}}
                    </li>
                    <li>
                        <b>{{ 'buyer.dados-pedido.tip-vendedor.email' | translate}}:</b> {{pedido.seller_email}}
                    </li>
                    <li>
                        <b>{{ 'buyer.dados-pedido.tip-vendedor.fone_radio' | translate}}:</b> {{pedido.seller_phone_radio}}
                    </li>
                </ul>
            </div>
        </ng-template>

        <div class="row cabecalho">
            <div class="col-md-12">
                <div class="row list-inline">
                    @if (this.userService.userIsCentral() && pedido.hasAguardandoConfirmacao) {
                        <div class="col-lg-1 col-md-1 col-xs-1 pr0 order-number cursor-pointer" (click)="copiarClipboardConfirmation(pedido.order_id)">
                            <div><i class="fa-tag fa iconOrder"></i> #{{pedido.order_id}}</div>
                        </div>
                    } @else {
                        <div class="col-lg-2 col-md-2 col-xs-2 pr0 order-number">
                            <div><i class="fa-tag fa iconOrder"></i> #{{pedido.order_id}}</div>
                        </div>
                    }
                    <div class="col-lg-2 col-md-2 col-xs-2 data"><i class="fa-calendar-o fa" tooltip="{{ 'buyer.dados-pedido.itens.cabecalho.data' | translate}}"></i>  {{pedido.data_confirmacao_pedido}}</div>
                    <div class="col-lg-5 col-md-5 col-xs-5 forma-pagamento">
                        <span><b>{{ 'buyer.dados-pedido.itens.cabecalho.forma-pagamento' | translate}}:</b> {{pedido.selected_payment_type == 0 ? ('buyer.dados-pedido.itens.cabecalho.pagamento-a-vista' | translate) : pedido.forma_pagamento}}</span>
                        @if (pedido.mudou_forma_pagamento || pedido.selected_payment_type == 0) {
                            <i class="fa fa-exclamation-circle text-warning" [tooltip]="pedido.selected_payment_type == 0 ? ('buyer.dados-pedido.itens.cabecalho.pagamento-a-vista-aviso' | translate) : ('buyer.dados-pedido.itens.cabecalho.forma-pagamento-antigo' | translate) + ': ' + pedido.forma_pagamento_original"></i>
                        }
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 pl0 pr0 fotos">
                        <div class="float-end">
                            @if (!checkVazio(agrupamento?.fotos) || !checkVazio(pedido?.notasFiscais) || !checkVazio(pedido.seller_notes) || !checkVazio(pedido.buyer_notes)) {
                                <button type="button" class="btn btn-labeled btn-light btn-sm btn-observacoes" data-toggle="modal" (click)="modal_observacoes_abrir(agrupamento.transaction_id, pedido.order_id, agrupamento.veiculo, agrupamento.fotos, pedido)">
                                    <span class="btn-label"><i class="fa fa-image"></i></span>
                                    {{ 'buyer.dados-pedido.itens.cabecalho.mais-info.botao' | translate}}
                                </button>
                            }
                        </div>
                    </div>
                    @if (!settingService.isMercadoPartsfy(agrupamento?.veiculo)) {
                        <div class="col-lg-2 col-md-2 col-xs-2 text-center condicoes" (click)="goToCompararCondicoes(pedido.transaction_id)">
                            {{ 'buyer.dados-pedido.itens.cabecalho.condicoes' | translate}} <i class="fa fa-external-link" aria-hidden="true"></i>
                        </div>
                    }
                </div>
            </div>
            @if (pedido.motivo) {
                <div class="col-md-12">
                    <span>
                        <b>{{ 'buyer.dados-pedido.itens.cabecalho.em-analise-motivo' | translate}}:</b>
                        {{pedido.motivo}}
                    </span>
                </div>
            }
        </div>

        <div>
            <div>
                <div class="card-body" style="padding:0">
                    <div class="card-header painelcabecalho">
                        <div class="titulo">
                            <b>{{pedido.supplier_name}}</b>
                            <b>/</b>
                            <div class="user-name">
                                <i-feather name="user" [ngbTooltip]="tipContent"></i-feather>
                                <small>{{pedido.seller_name}}</small>
                                <i class="fa icons click fa-whatsapp" (click)="openSellerWhatsapp(pedido)"></i>
                            </div>
                        </div>
                        @if (pedido?.had_cashback && userService.userRole() < 3) {
                            <span class="cashback text-success"><i class="fa fa-usd"></i> {{ 'buyer.dados-pedido.cashback' | translate}} <i class="fa fa-usd"></i></span>
                        }
                        <div>
                            @if (origem_tipo === 'comprador' && !pedido.isOnReturnMode && !pedido.isOnEditMode && showAlgumaEntregaConfirmada(pedido)) {
                                <div class="botoes float-end" tooltip="{{ 'buyer.dados-pedido.botoes.devolver' | translate}}">
                                    <a href="javascript:void(0)" class="chaticon float-end text-muted-custom" (click)="trocarDevolverHabilitar(pedido)">
                                        <i class="fa fa-undo text-danger"></i>
                                    </a>
                                </div>
                            }
                            @if (!pedido.isOnReturnMode && !esconderRefresh) {
                                <div class="botoes float-end">
                                    <a href="javascript:void(0)" class="float-end text-muted-custom" (click)="atualizar(pedido.transaction_id)" tooltip="{{ 'buyer.dados-pedido.botoes.atualizar' | translate}}">
                                        <i class="fa fa-refresh text-tertiary"></i>
                                    </a>
                                </div>
                            }
                            @if (showSendCrispMessage(pedido)) {
                                <div class="botoes float-end">
                                    <a href="javascript:void(0)" class="chaticon float-end text-muted-custom send-crisp-message" (click)="whatsapp_enviar(pedido)">
                                        <i class="fa icons fa-whatsapp popup fa-1x"></i>
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                    <div>
                        <table class="tabela-pedidos table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th class="quantity-header">{{ 'buyer.dados-pedido.itens.pecas.quantidade' | translate}}</th>
                                    <th class="part-name-header">{{ 'buyer.dados-pedido.itens.pecas.peca' | translate}}</th>
                                    <th class="brand-header">{{ 'buyer.dados-pedido.itens.pecas.marca' | translate}}</th>
                                    <th class="situation-header">{{ 'buyer.dados-pedido.itens.pecas.situacao.label' | translate}}</th>
                                    @if (!pedido?.pecas[0]?.is_not_order) {
                                        <th class="date-header">{{ 'buyer.dados-pedido.itens.pecas.entrega.label' | translate}}</th>
                                        <th class="value-header">{{ 'buyer.dados-pedido.itens.pecas.valor' | translate}}</th>
                                        <th class="discount-header">{{ 'buyer.dados-pedido.itens.pecas.desconto' | translate}}</th>
                                        <th>{{ 'buyer.dados-pedido.itens.pecas.total' | translate}}</th>
                                    }
                                    <th class="pedido_{{pedido.quotation_id}}">
                                        @if (pedido.showSelectAll && !pedido.isOnEditMode && (userService.userRole() === 1 || userService.userRole() === 64) && pedido.showSelectAllColumn) {
                                            <div class="form-check c-checkbox needsclick checkboxcot">
                                                <label class="needsclick" style="margin-top: 10px;">
                                                    <input type="checkbox" class="selectAll" (click)="selectAll($event, pedido)" />
                                                    <span class="fa fa-check"></span>
                                                </label>
                                            </div>
                                        }
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="tbodyhp">
                                @for (item of pedido.pecas; track item) {
                                    <tr [ngClass]="item.status >= StatusIdEnum.CotacaoCanceladaComprador ? 'rejeitado' : ''">
                                        <td class="text-center" [ngClass]="{'edition-mode': item.editValueSection }">
                                            @if (!item.editValueSection) {
                                                <span [ngClass]="{'editable-label': !item.lockQuantity && !pedido.isOnEditMode }" (click)="toggleValueSectionEdition(item, pedido, item.lockQuantity)">{{item.quantidade}}</span>
                                            } @else {
                                                <input type="number" class="form-control form-control-sm quantity" [(ngModel)]="item.newQuantidade" [disabled]="item.lockQuantity" pattern="[0-9]{3}" min="1" max="999" maxlength="3" (input)="limitQuantityInput(item, $event)" />
                                            }
                                        </td>
                                        <td class="coluna-peca">
                                            <ng-template #tipContent>{{ 'buyer.cotacao.area-respostas.resposta.pecas.codigo-antigo.label' | translate}}: {{item.tooltip_code}}</ng-template>
                                            <span class="truncate">{{item.peca}}</span>
                                            @if (agrupamento.buyer_erp != null && !item.is_synchronizable_erp) {
                                                <div class="sync-icon">
                                                    <i-feather name="wifi-off" [tooltip]="'buyer.cotacao.area-respostas.resposta.pecas.should-have-synced' | translate: { erp: agrupamento.buyer_erp }" [placement]="'left'"></i-feather>
                                                </div>
                                            }
                                            @if (item.mudou_codigo) {
                                                <i class="fa fa-exclamation-circle text-warning float-end" [ngbTooltip]="tipContent"></i>
                                            }
                                        </td>
                                        <td class="coluna-marca">
                                            @if (item.is_used) {
                                                <i class="fa fa-exclamation-circle float-end"  tooltip="{{ 'elemento.tipo-pecas.usada' | translate}}"></i>
                                            }
                                            <div>
                                                @if (item.part_type != 1) {
                                                    <div class="code">
                                                        <div class="truncate">{{item.brand}}</div>
                                                    </div>
                                                }
                                                <div class="truncate name">{{item.tipo_peca}}</div>
                                            </div>
                                        </td>
                                        <td class="pos-relative">
                                            {{item.situacao}}
                                            @if (item.situacao.indexOf('Rejeitado') > -1 || item.situacao.indexOf('Cancelado') > -1) {
                                                <small>({{ 'buyer.dados-pedido.itens.pecas.situacao.data' | translate}}: {{item.data_rejeicao}})</small>
                                            }
                                            @if ((item.delivery_type == 'PF' || item.delivery_type == 'BO') && item.situacao.indexOf('Rejeitado') == -1 && item.situacao.indexOf('Cancelado') == -1 && item.situacao.indexOf('Entregue') == -1) {
                                                <i class="fa fa-truck pos-absolute"></i>
                                            }
                                            @if (item.situacao.indexOf('Rejeitado') > -1 && item.rejected_information) {
                                                <i class="fa fa-exclamation-circle text-warning float-end"  tooltip="{{ 'buyer.dados-pedido.itens.pecas.situacao.tooltip-cancelamento' | translate}}: {{item.rejected_information}}"></i>
                                            }
                                        </td>
                                        @if (!item.is_not_order) {
                                            <td [ngClass]="{'edition-mode-date': item.editDate }">
                                                @if (!item.editDate) {
                                                    <span (click)="toggleDeliveryDateEdition(item, pedido)" [ngClass]="{'editable-label-date': !item.lockDate && !pedido.isOnEditMode && item.can_change_delivery_date}">{{item.previsao_entrega}}
                                                        @if (!item.can_change_delivery_date) {
                                                            <i class="fa fa-exclamation-circle text-warning ms-1" tooltip="{{ 'buyer.dados-pedido.itens.pecas.entrega.tooltip-bloqueio-data' | translate}}"></i>
                                                        }
                                                    </span>
                                                    @if (item.mudou_data_entrega) {
                                                        <i class="fa fa-exclamation-circle text-warning float-end" tooltip="{{ 'buyer.dados-pedido.itens.pecas.entrega.tooltip-mudanca-data' | translate}}: {{item.previsao_entrega_original}}"></i>
                                                    }
                                                } @else {
                                                    <div class="select-date-edit-mode">
                                                        <div class="input-group input-group-sm">
                                                            <input (ngModelChange)="editDateChanged($event, item)" class="form-control form-control-sm date" [disabled]="item.lockDate || (item.editIsBO ? item.editIsBO : null)" placeholder="dd/mm/yyyy" name="dp" [(ngModel)]="item.newDataEntrega" ngbDatepicker #d="ngbDatepicker" [container]="'body'" [firstDayOfWeek]="7" [minDate]="calendarMinDate" [maxDate]="calendarMaxDate" [markDisabled]="calendarMarkDisabled">
                                                            <div class="input-group-text cursor-pointer" (click)="!item.editIsBO && !item.lockDate ? d.toggle() : null"><i class="fa fa-calendar" aria-hidden="true"></i></div>
                                                        </div>
                                                        @if (!item.lockDate) {
                                                            @if (item.showPF) {
                                                                <div class="edit-prazo-pf">
                                                                    <input [disabled]="item.lockPF" type="checkbox" name="isPF" id="isPF_{{item.id}}" [(ngModel)]="item.editIsPF">
                                                                    <label for="isPF_{{item.id}}">{{ 'buyer.cotacao.area-respostas.resposta.editar.pf' | translate}}</label>
                                                                </div>
                                                            }
                                                            <div class="edit-prazo-bo">
                                                                <input type="checkbox" name="isBO" id="isBO_{{item.id}}" [(ngModel)]="item.editIsBO" (change)="setEditIsBO(item, pedido)">
                                                                <label for="isBO_{{item.id}}">{{ 'buyer.cotacao.area-respostas.resposta.editar.bo' | translate}}</label>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </td>
                                            <td class="text-end" [ngClass]="{'edition-mode': item.editValueSection }">
                                                @if(!item.editValueSection) {
                                                    <span [ngClass]="{'editable-label': !item.lockPrice && !pedido.isOnEditMode }" (click)="toggleValueSectionEdition(item, pedido, item.lockPrice)">{{item.valor_unitario | currency:'R$ '}}</span>
                                                } @else {
                                                    <div class="input-group input-group-sm value">
                                                        <span class="input-group-text">R$</span>
                                                        <input [disabled]="item.lockPrice" type="text" class="form-control form-control-sm" [(ngModel)]="item.newValorUnitario" currencyMask min="0" max="99999.99" maxlength="7" />
                                                    </div>
                                                }
                                            </td>
                                            <td class="text-end" [ngClass]="{'edition-mode': item.editValueSection }">
                                                @if(!item.editValueSection) {
                                                    <span [ngClass]="{'editable-label': !item.lockDiscount && !pedido.isOnEditMode }" (click)="toggleValueSectionEdition(item, pedido, item.lockDiscount)">{{item.desconto | currency:' '}}%</span>
                                                } @else {
                                                    <div class="input-group input-group-sm discount">
                                                        <input [disabled]="item.lockDiscount" type="text" class="form-control form-control-sm" [(ngModel)]="item.newDesconto" currencyMask min="0" max="99" maxlength="4" (blur)="onBlurDiscount(item)" />
                                                        <span class="input-group-text"><i class="fa fa-percent" aria-hidden="true"></i></span>
                                                    </div>
                                                }
                                            </td>
                                            <td class="text-end">{{buyerService.obterTotalPeca(item) | currency:'R$ '}}</td>
                                        }
                                        <td>
                                            @if((userService.userRole() === 1 || userService.userRole() === 64) && pedido.showSelectAllColumn) {
                                                @if((item.status >= StatusIdEnum.Pedido && !isFinalStatusInternal(item.status) && !isAwaitingConfirmationInternal(item.status) && item.status !== StatusIdEnum.AguardandoDevolucao) && !item.is_not_order && !pedido.isOnReturnMode) {
                                                    <div class="form-check c-checkbox needsclick checkboxcot">
                                                        <label class="needsclick">
                                                            <input type="checkbox" class="needsclick" [(ngModel)]="item.is_selected" />
                                                            <span class="fa fa-check"></span>
                                                        </label>
                                                    </div>
                                                }
                                                @if(item.status === StatusIdEnum.Entregue && pedido.isOnReturnMode) {
                                                    <div class="form-check c-checkbox needsclick checkboxcot">
                                                        <label class="needsclick">
                                                            <input type="checkbox" class="needsclick" [(ngModel)]="item.is_selected" />
                                                            <span class="fa fa-check"></span>
                                                        </label>
                                                    </div>
                                                }
                                                @if(item.status === StatusIdEnum.AguardandoDevolucao) {
                                                    <div class="pickup-column">
                                                        <i-feather class="text-danger" name="check-square" (click)="setPickedUp(item, pedido)"
                                                            container="body" ngbTooltip="{{ 'buyer.dados-pedido.botoes.marcar-devolvido' | translate}}">
                                                        </i-feather>
                                                    </div>
                                                }
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        @if (pedido.editFrete) {
                            <div class="edit-frete">
                                <div class="frete-select">
                                    <div class="linha">
                                        <div class="col-0-5">
                                            <label>{{ 'buyer.cotacao.area-respostas.resposta.editar.frete.titulo' | translate}}</label>
                                            <select name="frete" class="form-select form-select-sm m-b" [(ngModel)]="pedido.newFrete.tipo" (change)="editarResposta_AtualizarFrete(pedido.newFrete)">
                                                <option value="1">{{ 'elemento.generico-select.sim' | translate}}</option>
                                                <option value="2">{{ 'elemento.generico-select.nao' | translate}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                @if ((pedido.newFrete.tipo > 1)) {
                                    <div class="frete-price">
                                        <div class="linha">
                                            <label>{{ 'buyer.cotacao.area-respostas.resposta.editar.frete.valor' | translate}}</label>
                                        </div>
                                        <div class="linha input">
                                            <div class="col">
                                                <div class="input-group input-group-sm">
                                                    <span class="input-group-text">
                                                        <span>R$</span>
                                                    </span>
                                                    <input type="text" [(ngModel)]="pedido.newFrete.valor" [readonly]="(pedido.newFrete.nao_entrega || pedido.newFrete.conta_comprador) ? 'disabled' : null" class="form-control form-control-sm" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" min="0" max="100000" maxlength="7" (blur)="editarResposta_AtualizarFrete(pedido.newFrete)" />
                                                </div>
                                            </div>
                                            <div class="col" style="align-self: center;">
                                                <div class="c-checkbox needsclick" style="width: 100%;">
                                                    <label class="needsclick">
                                                        <input type="checkbox" value="" class="needsclick" [(ngModel)]="pedido.newFrete.conta_comprador" (change)="editarResposta_AtualizarFrete(pedido.newFrete)" [disabled]="(pedido.newFrete.nao_entrega) ? 'disabled' : null" />
                                                        <span class="fa fa-check"></span>{{ 'buyer.cotacao.area-respostas.resposta.editar.frete.conta-comprador' | translate}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
                @if (pedido.isOnEditMode) {
                    <div class="card-footer text-end">
                        <button type="button" class="btn btn-sm btn-light mr5" (click)="editarResposta_Cancelar(pedido)">{{ 'buyer.dados-pedido.botoes.cancelar' | translate}}</button>
                        <button type="button" class="btn btn-sm btn-primary" (click)="editarResposta_Salvar(pedido)">{{ 'buyer.dados-pedido.botoes.salvar' | translate}}</button>

                        <br /><br />

                        <span><b>{{ 'buyer.dados-pedido.itens.rodape.total' | translate}}:</b> {{ pedido?.total_com_frete | currency:'R$ ' }}</span><br>

                        <small>
                            {{ 'buyer.dados-pedido.itens.rodape.frete' | translate}}:
                            {{ pedido.frete_formatado }}
                            / {{ 'buyer.dados-pedido.itens.rodape.total-pecas' | translate}}: {{ pedido?.total | currency:'R$ ' }}
                        </small>
                    </div>
                } @else {
                    <div class="card-footer text-end">
                        @if (this.userService.userIsCentral() && buttonIsVisible(pedido.pecas, pedido)) {
                            <button type="button" class="btn btn-outline-primary btn-sm mr-sm" (click)="confirmarPedido(pedido)" [disabled]="!buttonIsEnableEdit(pedido.pecas) ? 'disabled' : null">{{ 'buyer.dados-pedido.botoes.confirmar-pedido' | translate}}</button>
                        }
                        @if (!pedido.isOnReturnMode) {
                            @if (this.userService.userIsCentral() && buttonIsVisibleConfirmado(pedido.pecas) && !settingService.isMercadoPartsfy(agrupamento?.veiculo)) {
                                <button type="button" class="btn btn-light btn-sm mr5 adicionar-complemento id_{{pedido.quotation_id}}" (click)="adicionar_complemento_modal_abrir($event, pedido.transaction_id, pedido.quotation_id, pedido.order_id, agrupamento.veiculo, pedido)">{{ 'buyer.dados-pedido.botoes.adicionar-complemento' | translate}}</button>
                            }

                            @if (buttonIsVisible(pedido.pecas)) {
                                @if (this.userService.userIsCentral()) {
                                    <button type="button" class="btn btn-outline-warning btn-sm mr-sm" (click)="toggleFreteEdition(pedido)" [disabled]="!buttonIsEnableEdit(pedido.pecas) ? 'disabled' : null">{{ 'buyer.dados-pedido.botoes.alterar-frete' | translate}}</button>
                                }
                                @if (userService.userRole() === 1) {
                                    <button type="button" class="btn btn-outline-danger btn-sm mr-sm" (click)="openCancelarEntregaModal(pedido)" [disabled]="!buttonIsEnableCancel(pedido.pecas) ? 'disabled' : null">{{ 'buyer.dados-pedido.botoes.cancelar-entrega' | translate}}</button>
                                }
                            }

                            @if ((userService.userRole() === 1 || userService.userRole() === 64) && buttonIsVisibleConfirmado(pedido.pecas)) {
                                <button type="button" class="btn btn-primary btn-sm" (click)="confirmarEntrega(pedido.order_id)" [disabled]="!buttonIsEnableConfirmation(pedido.pecas) ? 'disabled' : null">{{ 'buyer.dados-pedido.botoes.confirmar-entrega' | translate}}</button>
                            }
                        } @else {
                            <button type="button" class="btn btn-light btn-sm mr-sm" (click)="trocarDevolverVoltar(pedido)">{{ 'elemento.generico-botao.voltar' | translate}}</button>
                            <button type="button" class="btn btn-outline-danger btn-sm" (click)="trocarDevolverExecutar(pedido)" [disabled]="!trocarDevolverIsEnabled(pedido) ? 'disabled' : null">{{ 'buyer.dados-pedido.botoes.confirmar-devolucao' | translate}}</button>
                        }

                        <br /> <br />

                        <span><b>{{ 'buyer.dados-pedido.itens.rodape.total' | translate}}:</b> {{ pedido?.total_com_frete | currency:'R$ ' }}</span><br>

                        <small>
                            {{ 'buyer.dados-pedido.itens.rodape.frete' | translate}}:
                            {{ pedido.frete_formatado }}
                            / {{ 'buyer.dados-pedido.itens.rodape.total-pecas' | translate}}: {{ pedido?.total | currency:'R$ ' }}
                        </small>
                    </div>
                }
            </div>
        </div>
    </div>
}

<script type="text/ng-template" id="modalReabrirPedido">
    <div class="ngdialog-message">
        <h4 class="text-center">{{ 'buyer.dados-pedido.reabrir-pedido.titulo' | translate}}</h4>
        <h5>{{nome_usuario}}{{ 'buyer.dados-pedido.reabrir-pedido.corpo' | translate}}</h5>
        <div class="modal-buttons">
            <button type="button" (click)="confirm(0)" class="btn btn-light">{{ 'buyer.dados-pedido.reabrir-pedido.botoes.nao' | translate}}</button>
            <button type="button" (click)="confirm(1)" class="btn btn-success mr">{{ 'buyer.dados-pedido.reabrir-pedido.botoes.sim' | translate}}</button>
        </div>
    </div>
</script>

<ng-template #templateObservacoes>
    <div class="modal-header">
        <h4 class="modal-title">{{ cotacaoSelecionada?.veiculo }}</h4>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="modal_fechar();"></button>
    </div>
    <div class="modal-body">
        <ul ngbNav #nav="ngbNav" [(activeId)]="cotacaoSelecionada.active" class="nav-tabs">
            @if (cotacaoSelecionada?.fotos.length > 0) {
                <li [ngbNavItem]="1" [ngClass]="cotacaoSelecionada?.active === 1 ? 'active' : ''">
                    <a ngbNavLink>{{ 'buyer.dados-pedido.modal.abas.fotos.titulo' | translate}}</a>
                    <ng-template ngbNavContent>
                        <ngb-carousel>
                            @for (image of cotacaoSelecionada?.fotos; track image) {
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img class="image-to-zoom" [src]="image" alt="{{ 'buyer.dados-pedido.modal.abas.fotos.alt' | translate}}" (click)="zoomImage(image)">
                                    </div>
                                </ng-template>
                            }
                        </ngb-carousel>
                    </ng-template>
                </li>
            }
            @if (cotacaoSelecionada?.notas_fiscais.notasFiscais.length > 0) {
                <li [ngbNavItem]="2" [ngClass]="cotacaoSelecionada?.active === 2 ? 'active' : ''">
                    <a ngbNavLink>{{ 'buyer.dados-pedido.modal.abas.nfs.titulo' | translate}}</a>
                    <ng-template ngbNavContent>
                        <app-nota-fiscal [pedido]="cotacaoSelecionada?.notas_fiscais" [pdf_viewer_class]="'dados-pedido'" [is_central]="this.userService.userIsCentral()" [is_seller]="false" [transportadoras]="transportadoras" (salvarTransportadora)="salvarTransportadora($event)" (excluirNota)="excluirNota($event, pedidoSelecionado)" [permitirSalvar]="!cotacaoSelecionada?.finalizada"></app-nota-fiscal>
                    </ng-template>
                </li>
            }
            @if (cotacaoSelecionada?.seller_notes || cotacaoSelecionada?.buyer_notes) {
                <li [ngbNavItem]="3" [ngClass]="cotacaoSelecionada?.active === 3 ? 'active' : ''">
                    <a ngbNavLink>{{ 'buyer.dados-pedido.modal.abas.observacoes.titulo' | translate}}</a>
                    <ng-template ngbNavContent>
                        @if (!modal_visivel.comentarios) {
                            <div class="d-flex flex-wrap tab-observacoes-body">
                                @if (cotacaoSelecionada?.buyer_notes) {
                                    <div class="linha">
                                        <div class="titulo">
                                            <label class="col-form-label">{{'buyer.dados-pedido.modal.abas.observacoes.corpo.obs-oficina' | translate}}:</label>
                                        </div>
                                        <section class="d-flex flex-wrap striped bordered card-body">
                                            {{cotacaoSelecionada?.buyer_notes}}
                                        </section>
                                    </div>
                                }
                                @if (cotacaoSelecionada?.seller_notes) {
                                    <div class="linha">
                                        <div class="titulo">
                                            <label class="col-form-label">{{'buyer.dados-pedido.modal.abas.observacoes.corpo.obs-fornecedor' | translate}}:</label>
                                        </div>
                                        <section class="d-flex flex-wrap striped bordered card-body">
                                            {{cotacaoSelecionada?.seller_notes}}
                                        </section>
                                    </div>
                                }
                            </div>
                        }
                    </ng-template>
                </li>
            }
        </ul>
        <div [ngbNavOutlet]="nav"></div>
    </div>
    <div class="modal-footer">
        <button id="closeModal" type="button" class="btn btn-light" (click)="modal_fechar();">{{ 'buyer.dados-pedido.botoes.fechar' | translate}}</button>
    </div>
</ng-template>

<ng-template #templateCancelarEntrega>
    <div class="modal-header">
        <div class="d-flex flex-column">
            <h4 class="modal-title">{{ 'buyer.dados-pedido.cancelar-entrega.titulo' | translate}}</h4>
            <span class="modal-subtitle">
                @if (!isMercadoPartsfy) {
                    <span>{{ 'buyer.dados-pedido.cancelar-entrega.subtitulo' | translate}}</span>
                }
                <span class="dados-veiculo">{{agrupamento.veiculo}}</span>
            </span>
        </div>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="modal_fechar();"></button>
    </div>
    <div class="modal-body modal-cancelar">
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.cancelar-entrega.legenda' | translate}}</label>
                    <select name="reason" class="form-select m-b" (change)="cancelarEntregaChangeValue()">
                        @for (reason of cancelReasons; track reason) {
                            <option value="{{reason.id}}" [attr.needs-comment]="reason.needs_comment">{{reason.description}}</option>
                        }
                    </select>
                </div>
            </div>
        </div>
        <div class="row" style="height: 113px;">
            <div class="col-lg-12">
                <div class="mb-3 form-group">
                    <textarea name="comment" [disabled]="!excluirCotacaoNeedsComment" rows="4" placeholder="{{'elemento.generico-input.placeholder' | translate}}" class="form-control comment" required></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="closeModal" type="button" data-dismiss="modal" class="btn btn-light" (click)="modal_fechar();">{{ 'elemento.generico-botao.fechar' | translate}}</button>
        <button id="btnSalvar" type="button" class="btn btn-primary outlined" ng-disabled="selected_reason == undefined" (click)="cancelarEntrega()">{{ 'buyer.dados-pedido.cancelar-entrega.botao.nao-reabrir' | translate}}</button>
        <button id="btnSalvar" type="button" class="btn btn-primary" ng-disabled="selected_reason == undefined" (click)="cancelarEntrega(true)">{{ (isMercadoPartsfy ? 'buyer.dados-pedido.cancelar-entrega.botao.recomprar' : 'buyer.dados-pedido.cancelar-entrega.botao.reabrir') | translate}}</button>
    </div>
    <ngx-ui-loader [loaderId]="'loader-cancelar-entrega'"></ngx-ui-loader>
</ng-template>

<dados-pedido-adicionar-complemento [cotacaoSelecionada]="cotacaoSelecionada" [deliveryTimes]="deliveryTimes" [feriados]="feriados" [visivel]="modal_visivel.adicionar_complemento" (fechar)="adicionar_complemento_modal_fechar($event)"></dados-pedido-adicionar-complemento>
